/* =========================================================================
   nbd-article-legacy.js — behaviour for the 8 self-styled /blogs/news
   articles (the ones whose bodies wrap themselves in id="nb").

   Was ~830 bytes of inline <script> in each of the 8 article bodies, eight
   near-identical copies. That is also exactly where 103 bytes of JavaScript
   went missing on 17 Aug 2026 and broke the FAQ accordions on
   best-powerlifting-belt-india-2026-complete-guide for three verification
   passes. Nothing behavioural belongs in an article body any more.

   Loaded with `defer` by sections/nbd-article.liquid, in legacy mode only.
   toggleAcc must stay a global function declaration — the article bodies call
   it from inline onclick="toggleAcc(this)".
   ========================================================================= */

function toggleAcc(btn) {
  if (!btn) return;
  var body = btn.nextElementSibling;
  var isOpen = btn.classList.contains('open');
  var all = document.querySelectorAll('.acc-btn');
  for (var i = 0; i < all.length; i++) {
    all[i].classList.remove('open');
    if (all[i].nextElementSibling) all[i].nextElementSibling.classList.remove('open');
  }
  if (!isOpen) {
    btn.classList.add('open');
    if (body) body.classList.add('open');
  }
}

/* The old inline copy in how-to-break-in-a-lever-belt ran an unguarded
   requestAnimationFrame loop against elements it never null-checked, so on a
   page where they were absent it threw on the first frame and then span
   forever. Keeping the accordion delegated as a fallback means an article
   whose markup loses its inline onclick still opens. */
document.addEventListener('click', function (e) {
  if (!e.target || !e.target.closest) return;
  var btn = e.target.closest('.acc-btn');
  if (!btn || btn.hasAttribute('onclick')) return;
  toggleAcc(btn);
});


/* =========================================================================
   SIZE FINDER — belt size guide article only.
   No-ops on every other article: it returns immediately if #szFinder is not
   on the page, so the other seven pay nothing but the bytes.

   The ladder and the boundary rule are the article's own published chart and
   its step 05 ("land exactly on a boundary -> go one size up"). If the chart
   changes, change LADDER in the same commit.
   ========================================================================= */
(function () {
  var root = document.getElementById('szFinder');
  if (!root) return;

  /* cm bands, and the chart's OWN printed inch bands. They are not exact
     conversions of each other — 2XL is 110-120cm, printed as 43.5"-47" — so an
     inch entry is matched against the inch column the reader can actually see.
     47" against the cm ladder returns 2XL while the chart shows 47" as the
     start of 3XL, and the reader would rightly stop trusting the widget. */
  var LADDER = [
    ['XS',  60,  70],
    ['S',   70,  80],
    ['M',   80,  90],
    ['L',   90, 100],
    ['XL', 100, 110],
    ['2XL',110, 120],
    ['3XL',120, 130],
    ['4XL',130, 140]
  ];
  var LADDER_IN = [
    ['XS', 23.5, 27.5],
    ['S',  27.5, 31.5],
    ['M',  31.5, 35.5],
    ['L',  35.5, 39.5],
    ['XL', 39.5, 43.5],
    ['2XL',43.5, 47.0],
    ['3XL',47.0, 51.0],
    ['4XL',51.0, 55.0]
  ];
  var WA  = 'https://wa.me/919996268668';
  var SHOP = '/collections/the-nbd-belts';

  var input = document.getElementById('szInput');
  var out   = document.getElementById('szOut');
  var go    = document.getElementById('szGo');
  var units = root.querySelectorAll('.szf-u');
  var unit  = 'cm';

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) {
    return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  for (var i = 0; i < units.length; i++) {
    (function (b) {
      b.addEventListener('click', function () {
        unit = b.getAttribute('data-unit');
        for (var j = 0; j < units.length; j++) units[j].classList.remove('is-on');
        b.classList.add('is-on');
        input.setAttribute('placeholder', unit === 'cm' ? 'e.g. 92' : 'e.g. 36');
        /* min/max follow the unit, or a legitimate 24" entry shows as invalid */
        input.setAttribute('min', unit === 'cm' ? '40' : '16');
        input.setAttribute('max', unit === 'cm' ? '220' : '86');
        if (input.value) find();
      });
    })(units[i]);
  }

  var scope = document.getElementById('nbdArtBody') || document;

  function clearRows() {
    var rows = scope.querySelectorAll('.sz-table tr.is-match');
    for (var i = 0; i < rows.length; i++) rows[i].classList.remove('is-match');
  }

  function markRow(size) {
    clearRows();
    var rows = scope.querySelectorAll('.sz-table tbody tr');
    for (var i = 0; i < rows.length; i++) {
      var c = rows[i].cells && rows[i].cells[0];
      if (!c) continue;
      if ((c.textContent || '').trim().toUpperCase() === size) {
        rows[i].classList.add('is-match');
        return rows[i];
      }
    }
    return null;
  }

  function show(html) { out.innerHTML = html; out.hidden = false; }

  function find() {
    var raw = parseFloat(String(input.value).replace(',', '.'));
    if (isNaN(raw) || raw <= 0) {
      clearRows();
      show('<p class="szf-note szf-err">Enter your waist measurement first — ' +
           'measured at belly button height, standing relaxed.</p>');
      return;
    }
    var inches = unit === 'in';
    var cm = inches ? raw * 2.54 : raw;
    var L = inches ? LADDER_IN : LADDER;
    var v = raw;
    var shown = inches
      ? (raw + '&Prime; (' + (Math.round(cm * 10) / 10) + 'cm)')
      : (raw + 'cm');

    /* the top of the last band is INCLUSIVE — the chart lists 4XL as 130-140cm */
    if (v < L[0][1] || v > L[L.length - 1][2]) {
      clearRows();
      show('<p class="szf-note">The chart runs from <strong>60cm to 140cm</strong> (23.5&Prime; to 55&Prime;) and ' +
           esc(String(shown)).replace('&amp;Prime;', '&Prime;') +
           ' sits outside it. Message us and we will confirm the right size for you ' +
           'before you order.</p>' +
           '<div class="szf-acts"><a class="szf-btn" href="' + WA +
           '" target="_blank" rel="noopener">Confirm on WhatsApp</a></div>');
      return;
    }

    /* boundary -> go one size up, per step 05 of this guide */
    var size = null, onBoundary = false, band = null, bandIdx = -1;
    for (var i = 0; i < L.length; i++) {
      var lo = L[i][1], hi = L[i][2], last = (i === L.length - 1);
      if (v >= lo && (v < hi || (last && v <= hi))) {
        size = L[i][0]; band = L[i]; bandIdx = i;
        onBoundary = Math.abs(v - lo) < 0.05 && i > 0;
        break;
      }
    }
    if (!size) return;

    var row = markRow(size);
    var bandTxt = inches ? (band[1] + '&Prime;–' + band[2] + '&Prime;')
                         : (band[1] + '–' + band[2] + 'cm');
    var note = onBoundary
      ? 'You are exactly on the boundary between <strong>' + L[bandIdx - 1][0] +
        '</strong> and <strong>' + size + '</strong>. This guide says go one size up, so ' +
        '<strong>' + size + '</strong> is your size — a belt you cannot brace into is a belt you will not wear.'
      : 'Your waist sits inside the <strong>' + bandTxt + '</strong> band. ' +
        'That is the size to order. Snug, never painful, with room to brace into.';
    if (inches) {
      note += ' Measuring in centimetres is more accurate — re-check in cm if you are close to a boundary.';
    }

    show(
      '<div class="szf-size"><b>' + size + '</b><span>' + shown + ' at belly button height</span></div>' +
      '<p class="szf-note">' + note + '</p>' +
      '<div class="szf-acts">' +
        '<a class="szf-btn" href="' + SHOP + '">Shop NBD belts</a>' +
        '<a class="szf-btn ghost" href="' + WA + '" target="_blank" rel="noopener">Confirm on WhatsApp</a>' +
      '</div>'
    );

    if (row && row.scrollIntoView) {
      try { row.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      catch (e) { row.scrollIntoView(); }
    }
  }

  go.addEventListener('click', find);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); find(); }
  });
})();
